define(function(require, exports, module) {
    'use strict';
    const config = require('config');

    const getDynamicTagValue = (dynamicTagName) => {
        const dynamicTags = config.get('dynamicTags');

        if (dynamicTags && dynamicTags[`DTAG_${dynamicTagName}`]) {
            return dynamicTags[`DTAG_${dynamicTagName}`];
        }

        console.warn(`Dynamic Tag ${dynamicTagName} doesn't exist`);
    };

    module.exports = getDynamicTagValue;
});
